import type { SVGProps } from "react";

export const ChevronRightIcon = ({
  width = "5",
  height = "8",
  props,
}: {
  width?: string;
  height?: string;
  props?: SVGProps<SVGSVGElement>;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 5 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 7L4 4L1 1"
      stroke="currentColor"
      strokeWidth="0.666667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
